export default "__VITE_ASSET__a3950a8f__"